import template from './topdata-login-attempt-log-detail.html.twig';
import './topdata-login-attempt-log-detail.scss';

const { Mixin } = Shopware;
const { Criteria } = Shopware.Data;
const { date } = Shopware.Utils.format;

Shopware.Component.register('topdata-login-attempt-log-detail', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('notification'),
    ],

    data() {
        return {
            item: null,
            isLoading: false,
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('tdcl_login_attempt_log');
        },

        logId() {
            return this.$route.params.id;
        },
    },

    created() {
        this.loadEntity();
    },

    methods: {
        loadEntity() {
            this.isLoading = true;

            const criteria = new Criteria();
            criteria.addAssociation('customer');

            this.repository.get(this.logId, Shopware.Context.api, criteria).then((result) => {
                this.item = result;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        getSuccessVariant(success) {
            return success ? 'success' : 'danger';
        },

        getSuccessLabel(success) {
            return success
                ? this.$tc('TopdataContactLoginSW6.loginLog.success.1')
                : this.$tc('TopdataContactLoginSW6.loginLog.success.0');
        },

        getAttemptTypeLabel(attemptType, contactId, customerId) {
            if (attemptType === 'login') {
                if (contactId) {
                    return this.$tc('TopdataContactLoginSW6.loginLog.attemptType.contact_login');
                }
                if (customerId) {
                    return this.$tc('TopdataContactLoginSW6.loginLog.attemptType.login_success_customer');
                }
                return this.$tc('TopdataContactLoginSW6.loginLog.attemptType.login');
            }
            return this.$tc(`TopdataContactLoginSW6.loginLog.attemptType.${attemptType}`, 0, attemptType);
        },

        getErrorMessageLabel(errorMessage) {
            const key = `TopdataContactLoginSW6.loginLog.errorMessage.${errorMessage}`;
            const translated = this.$tc(key, 0, errorMessage);
            return translated !== key ? translated : errorMessage;
        },

        formatDate(value) {
            if (!value) {
                return '';
            }
            return date(value, {
                hour: '2-digit',
                minute: '2-digit',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
        },
    },
});
